/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject, Input } from '@angular/core';
import { uuid } from '@src/app/model/abstract-object';
import { User } from '@src/app/model/user';
import { UserService } from '@src/app/modules/user/user.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    imports: [MatTooltipModule]
})
export class AvatarComponent {
    userService = inject(UserService);

    myUser: User = {id: 'rubbish', name: '', avatar: null} as User;

    myId: uuid;
    @Input() set id(value: uuid) {
        this.myId = value;
        if (value) {
            this.userService.getUser(this.myId).subscribe(user => {
                this.myUser = user;
            });
        }
    }
}
